import { Link } from "react-router-dom";

import OfferStatusBadge from "./OfferStatusBadge";

import {
  formatMoney,
  formatOfferDate
} from "../utils/offer.utils";

const OfferTable = ({
  offers = [],
  loading = false,
  onDelete,
  canDelete = false
}) => {
  if (loading) {
    return (
      <div className="offer-table__loading">
        Loading offers...
      </div>
    );
  }

  if (!offers.length) {
    return (
      <div className="offer-table__empty">
        No offers found.
      </div>
    );
  }

  return (
    <div className="offer-table">
      <table>
        <thead>
          <tr>
            <th>Offer</th>
            <th>Client</th>
            <th>Query</th>
            <th>Status</th>
            <th>Total</th>
            <th>Valid Until</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {offers.map((offer) => (
            <tr key={offer.id}>
              <td>
                <Link
                  to={`/offers/${offer.id}`}
                >
                  <strong>
                    {offer.offer_number}
                  </strong>
                </Link>
              </td>

              <td>
                <div>
                  {offer.client_name}
                </div>

                {offer.company_name && (
                  <small>
                    {offer.company_name}
                  </small>
                )}
              </td>

              <td>
                {offer.query_subject ||
                  "—"}
              </td>

              <td>
                <OfferStatusBadge
                  status={offer.status}
                />
              </td>

              <td>
                <strong>
                  {formatMoney(
                    offer.total_amount,
                    offer.currency
                  )}
                </strong>
              </td>

              <td>
                {formatOfferDate(
                  offer.valid_until
                )}
              </td>

              <td>
                {formatOfferDate(
                  offer.created_at
                )}
              </td>

              <td>
                <Link
                  to={`/offers/${offer.id}`}
                >
                  View
                </Link>

                {offer.status ===
                  "DRAFT" && (
                  <>
                    {" "}
                    <Link
                      to={`/offers/${offer.id}/edit`}
                    >
                      Edit
                    </Link>
                  </>
                )}

                {canDelete &&
                  offer.status ===
                    "DRAFT" &&
                  onDelete && (
                    <button
                      type="button"
                      onClick={() =>
                        onDelete(offer)
                      }
                    >
                      Delete
                    </button>
                  )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OfferTable;